import { Dot } from "@xola/ui-kit";
import React from "react";
import { Event, EventGuide, EventGuideStatus, Guide } from "types";
import { NoTranslate } from "@/components/Common/NoTranslate";
import { useResource } from "@/hooks/useResource";

interface GuideNameProps {
    event: Event;
    eventGuide: EventGuide;
}

const statusColors = {
    [EventGuideStatus.PENDING]: "caution",
    [EventGuideStatus.DECLINED]: "danger",
    [EventGuideStatus.CONFIRMED]: "success",
};

export const GuideName = ({ event, eventGuide }: GuideNameProps) => {
    const guideId = eventGuide.guide.id;
    const color = statusColors[eventGuide.status];

    const { data: guide } = useResource<Guide>(["sellers", event.seller.id, "guides", guideId]);

    return (
        <NoTranslate data-guide-id={guideId} className="ui-guide-name">
            {event.guides.length > 1 ? <Dot color={color} className="mr-1 align-middle" /> : null}
            {guide ? <span title={guide.name}>{guide.name}</span> : guideId}
        </NoTranslate>
    );
};
